<template>
  <div class="container">
    <div class="el-tabs__content">
      <div class="el-tabs--border-card border  rounded">
        <el-form
          :label-width="'30%'"
          :model="myInfoFormModel"
          :rules="rules"
          ref="myInfoFormModel"
          class="el-form"
        >
          <h4 class="p-3 second_title">Business Infomation</h4>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Legal Business Name" prop="businessName">
                <el-input type="text" :maxlength="50" placeholder v-model="myInfoFormModel.businessName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Trade Name" prop="tradeName">
                <el-input type="text" :maxlength="50" placeholder v-model="myInfoFormModel.tradeName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Email" prop="info4">
                <el-input type="text" placeholder :disabled="true" v-model="myInfoFormModel.info4"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="EIN" prop="info6">
                <el-input type="text" placeholder="EIN(9 digits only)" :maxlength="10" onkeypress="return event.keyCode>=48&&event.keyCode<=57" v-model="myInfoFormModel.info6" @input="handleTinInput"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Business Phone" prop="info24">
                <el-input type="tel" :maxlength="10" onkeypress="return event.keyCode>=48&&event.keyCode<=57" v-model="myInfoFormModel.info24"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Company Email" prop="companyEmail">
                <el-input type="text" v-model="myInfoFormModel.companyEmail"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="State of Incorporation" prop="stateOfIncorporation" class="step-form__form-item--with-unit">
                <el-select v-model="myInfoFormModel.stateOfIncorporation" placeholder="State of Incorporation">
                  <el-option
                    v-for="item in stateS"
                    :key="item.text"
                    :label="item.text"
                    :value="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="Industry Type" prop class="step-form__form-item--with-unit">
                <el-select v-model="myInfoFormModel.industry" placeholder="Industry Type" style="width:100%"> 
                  <el-option
                    v-for="item in industries"
                    :key="item.text"
                    :label="item.text"
                    :value="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item
                label="Company Structure"
                prop="Structure"
                class="step-form__form-item--with-unit"
              >
                <el-select v-model="myInfoFormModel.structure" placeholder="Company Structure" style="width:100%">
                  <el-option
                    v-for="item in structures"
                    :key="item.text"
                    :label="item.text"
                    :value="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Address" prop="info21">
                <el-input type="text" :rows="2" placeholder v-model="myInfoFormModel.info21"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Address Line 2" prop="address2">
                <el-input type="text" :rows="2" placeholder v-model="myInfoFormModel.address2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="City" prop="info18">
                <el-input type="text" placeholder v-model="myInfoFormModel.info18"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="State" prop="state" class="step-form__form-item--with-unit">
                <el-select v-model="myInfoFormModel.state" placeholder="Please Select State">
                  <el-option
                    v-for="item in stateS"
                    :key="item.text"
                    :label="item.text"
                    :value="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Zip" prop="zip">
                <el-input type="text" placeholder v-model="myInfoFormModel.zip"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Company Website" prop="website">
                <el-input type="text" placeholder v-model="myInfoFormModel.website"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Years In Business" prop="yearsInBusiness">
                <el-input type="number" placeholder v-model="myInfoFormModel.yearsInBusiness" onkeypress="return event.keyCode>=48&&event.keyCode<=57"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Business Start Date" prop="businessStartDate">
                <el-input type="text" placeholder="MM/DD/YYYY" v-model="myInfoFormModel.businessStartDate"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Revenue/Gross Sales" prop="info28">
                <el-input type="number" :maxlength="16" placeholder="Numbers only" v-model="myInfoFormModel.revenue" onkeypress="return event.keyCode>=48&&event.keyCode<=57"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="Own or Rent Business Location" prop class="step-form__form-item--with-unit">
                <el-select v-model="myInfoFormModel.ownOrRentLocation" placeholder="Select" style="width:100%"> 
                  <el-option
                    v-for="item in ownOrRent"
                    :key="item.text"
                    :label="item.text"
                    :value="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="Rent or Mortgage Monthy Payment" prop="rentOrMortgageAmount">
                <el-input type="number" placeholder v-model="myInfoFormModel.rentOrMortgageAmount" onkeypress="return event.keyCode>=48&&event.keyCode<=57"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="height: 100px;">
            <el-col :span="18">
              <el-form-item label="Business Description" class="margin-bottom-0">
                <el-input type="textarea" placeholder="Please include details by describing your business, revenue stream, and specifics to the need for this loan. For Equipment Financing, please also add how this equipment loan will increase your revenue (i.e. debt service coverage ration before and after loan) and what is the timing you will start to see a contribution to your revenue?" v-model="myInfoFormModel.businessDesc" :rows=3></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="text-center">
          <el-button
            type="primary"
            :loading="isLoading"
            class="personal-center-form__submit"
            @click="submitForm"
          >submit</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";
import _ from "lodash";
import api from "../../vuex/api/index";

export default {
  data() {
    const assignValidator = (message, trigger = "blur") =>
      Object.assign(
        {
          //        required: true,
          message,
          trigger
        },
        {
          validator: (rules, value, callback) => {
            if (_.isNaN(Number(value))) {
              callback(new Error(`${message}`));
            } else {
              callback();
            }
          }
        }
      );
    return {
      stateS: [
        { value: 'Alabama', text: 'Alabama' },
        { value: 'Alaska', text: 'Alaska' },
        { value: 'Arizona', text: 'Arizona' },
        { value: 'Arkansas', text: 'Arkansas' },
        { value: 'California', text: 'California' },
        { value: 'Colorado', text: 'Colorado' },
        { value: 'Connecticut', text: 'Connecticut' },
        { value: 'Delaware', text: 'Delaware' },
        { value: 'Florida', text: 'Florida' },
        { value: 'Georgia', text: 'Georgia' },
        { value: 'Hawaii', text: 'Hawaii' },
        { value: 'Idaho', text: 'Idaho' },
        { value: 'Illinois', text: 'Illinois' },
        { value: 'Indiana', text: 'Indiana' },
        { value: 'Iowa', text: 'Iowa' },
        { value: 'Kansas', text: 'Kansas' },
        { value: 'Kentucky', text: 'Kentucky' },
        { value: 'Louisiana', text: 'Louisiana' },
        { value: 'Maine', text: 'Maine' },
        { value: 'Maryland', text: 'Maryland' },
        { value: 'Massachusetts', text: 'Massachusetts' },
        { value: 'Michigan', text: 'Michigan' },
        { value: 'Minnesota', text: 'Minnesota' },
        { value: 'Mississippi', text: 'Mississippi' },
        { value: 'Missouri', text: 'Missouri' },
        { value: 'Montana', text: 'Montana' },
        { value: 'Nebraska', text: 'Nebraska' },
        { value: 'Nevada', text: 'Nevada' },
        { value: 'New Hampshire', text: 'New Hampshire' },
        { value: 'New Jersey', text: 'New Jersey' },
        { value: 'New Mexico', text: 'New Mexico' },
        { value: 'New York', text: 'New York' },
        { value: 'North Carolina', text: 'North Carolina' },
        { value: 'North Dakota', text: 'North Dakota' },
        { value: 'Ohio', text: 'Ohio' },
        { value: 'Oklahoma', text: 'Oklahoma' },
        { value: 'Oregon', text: 'Oregon' },
        { value: 'Pennsylvania', text: 'Pennsylvania' },
        { value: 'Rhode Island', text: 'Rhode Island' },
        { value: 'South Carolina', text: 'South Carolina' },
        { value: 'South Dakota', text: 'South Dakota' },
        { value: 'Tennessee', text: 'Tennessee' },
        { value: 'Texas', text: 'Texas' },
        { value: 'Utah', text: 'Utah' },
        { value: 'Vermont', text: 'Vermont' },
        { value: 'Virginia', text: 'Virginia' },
        { value: 'Washington', text: 'Washington' },
        { value: 'West Virginia', text: 'West Virginia' },
        { value: 'Wisconsin', text: 'Wisconsin' },
        { value: 'Wyoming', text: 'Wyoming' }
      ],
      isEditable: "0",
      Idcard: "0",
      value: "",
      isLoading: false,
      ownOrRent : [
        {
          value:'Own',
          text:'Own'
        },
        {
          value:'Rent',
          text:'Rent'
        }        
      ],
      industries: [
        {
          value:'Agriculture - Farming & Livestock',
          text:'Agriculture - Farming & Livestock'
        },
        {
          value:'Consumer Discretionary - Automotive',
          text:'Consumer Discretionary - Automotive'
        },
        {
          value:'Consumer Discretionary - Bars & Restaurants',
          text:'Consumer Discretionary - Bars & Restaurants'
        },
        {
          value:'Consumer Discretionary - DTC',
          text:'Consumer Discretionary - DTC'
        },
        {
          value:'Consumer Discretionary - Homebuilding',
          text:'Consumer Discretionary - Homebuilding'
        },
        {
          value:'Consumer Discretionary - Hospitality',
          text:'Consumer Discretionary - Hospitality'
        },
        {
          value:'Consumer Discretionary - Leisure',
          text:'Consumer Discretionary - Leisure'
        },
        {
          value:'Consumer Discretionary - Media',
          text:'Consumer Discretionary - Media'
        },
        {
          value:'Consumer Discretionary - Non-traditional Food',
          text:'Consumer Discretionary - Non-traditional Food'
        },
        {
          value:'Consumer Discretionary - Private Passenger Transportation',
          text:'Consumer Discretionary - Private Passenger Transportation'
        },
        {
          value:'Consumer Discretionary - Services',
          text:'Consumer Discretionary - Services'
        },
        {
          value:'Consumer Staples - Food & Beverages',
          text:'Consumer Staples - Food & Beverages'
        },
        {
          value:'Consumer Staples - Non-durable Goods',
          text:'Consumer Staples - Non-durable Goods'
        },
        {
          value:'Consumer Staples - Public Passenger Transportation',
          text:'Consumer Staples - Public Passenger Transportation'
        },
        {
          value:'Energy - Coal & Consumables',
          text:'Energy - Coal & Consumables'
        },
        {
          value:'Energy - Oil & Gas',
          text:'Energy - Oil & Gas'
        },
        {
          value:'Energy - Renewables',
          text:'Energy - Renewables'
        },
        {
          value:'Financial Services - Diversified',
          text:'Financial Services - Diversified'
        },
        {
          value:'Financial Services - Non-traditional',
          text:'Financial Services - Non-traditional'
        },
        {
          value:'Health Care - Equipment Manufacturing',
          text:'Health Care - Equipment Manufacturing'
        },
        {
          value:'Health Care - Life Sciences',
          text:'Health Care - Life Sciences'
        },
        {
          value:'Health Care - Services',
          text:'Health Care - Services'
        },
        {
          value:'Industrial - Aerospace & Defense',
          text:'Industrial - Aerospace & Defense'
        },
        {
          value:'Industrial- Commercial Printing',
          text:'Industrial- Commercial Printing'
        },
        {
          value:'Industrial - Construction Services',
          text:'Industrial - Construction Services'
        },
        {
          value:'Industrial - Distribution and Logistics',
          text:'Industrial - Distribution and Logistics'
        },
        {
          value:'Industrial - Diversified Manufacturing',
          text:'Industrial - Diversified Manufacturing'
        },
        {
          value:'Industrial - Electrical Components',
          text:'Industrial - Electrical Components'
        },
        {
          value:'Industrial - Environmental & Facilities Services',
          text:'Industrial - Environmental & Facilities Services'
        },
        {
          value:'Industrial - Industrial Transportation',
          text:'Industrial - Industrial Transportation'
        },
        {
          value:'Industrial - Long-haul Transportation',
          text:'Industrial - Long-haul Transportation'
        },
        {
          value:'Industrial - Machinery and Equipment',
          text:'Industrial - Machinery and Equipment'
        },
        {
          value:'Industrial - Short-haul Transportation',
          text:'Industrial - Short-haul Transportation'
        },
        {
          value:'Infrastructure - Ground',
          text:'Infrastructure - Ground'
        },
        {
          value:'Infrastructure - Utilities',
          text:'Infrastructure - Utilities'
        },
        {
          value:'Materials - Chemical Products',
          text:'Materials - Chemical Products'
        },
        {
          value:'Materials - Construction Products',
          text:'Materials - Construction Products'
        },
        {
          value:'Materials - Forest Products',
          text:'Materials - Forest Products'
        },
        {
          value:'Materials - Metals & Mining',
          text:'Materials - Metals & Mining'
        },
        {
          value:'Materials - Non-metal Recycling',
          text:'Materials - Non-metal Recycling'
        },
        {
          value:'Materials - Precious Metals',
          text:'Materials - Precious Metals'
        },
        {
          value:'Technology - Commercial Services',
          text:'Technology - Commercial Services'
        },
        {
          value:'Technology - Equipment Manufacturing',
          text:'Technology - Equipment Manufacturing'
        },
        {
          value:'Technology - IT Services',
          text:'Technology - IT Services'
        },
        {
          value:'Technology - Network Operators',
          text:'Technology - Network Operators'
        }
      ],
      structures: [
        { value: 'C corp', text: 'C corp' },
        { value: 'Federal Government', text: 'Federal Government' },
        {
          value: 'Limited Liability Partnership',
          text: 'Limited Liability Partnership'
        },
        {
          value: 'Limited Liability Limited Partnership',
          text: 'Limited Liability Limited Partnership'
        },
        { value: 'LLC', text: 'LLC' },
        { value: 'Non Profit', text: 'Non Profit' },
        { value: 'Partnership', text: 'Partnership' },
        {
          value: 'Professional Corporation',
          text: 'Professional Corporation'
        },
        { value: 'S Corp', text: 'S Corp' },
        { value: 'Sole Prop', text: 'Sole Prop' },
        { value: 'State/Local Government', text: 'State/Local Government' },
        { value: 'Other', text: 'Other' }
      ],
      myInfoFormModel: {
        baseProductRepayName: "2",
        baseProductRepay: "3",
        info1: "", //å®¢æˆ·ç¼–ç �
        info2: "", //å®¢æˆ·ç±»åž‹
        info3: "", //å®¢æˆ·å§“å��
        info4: "", //REGISTRATIONæ‰‹æœºå�·
        info5: "0", //è¯�ä»¶ç±»åž‹
        info6: "", //è¯�ä»¶å�·ç �
        info7: "", //æ€§åˆ«
        info8: "", //å‡ºç”Ÿæ—¥æœŸ
        info9: "", //å­¦åŽ†
        info10: "", //æ¯•ä¸šé™¢æ ¡
        info11: "", //æ‰€å±žåŒºåŸŸ
        info12: "", //æˆ·åˆ«
        info13: "", //æˆ·ç±�åœ°å�€
        info14: "", //å©šå§»çŠ¶å†µ
        info15: "", //å®¶åº­æˆ�å‘˜
        info16: "", //æ˜¯å�¦æœ‰å­�å¥³
        info17: "", //ä½�å®…çŠ¶å†µ
        info18: "", //å±…ä½�åŸŽå¸‚
        info19: "", //å±…ä½�åœ°å�€
        businessName: "",
        tradeName: "",
        companyEmail: "",
        stateOfIncorporation: "",
        website: "",
        businessDesc: "",
        info21: "", //å�•ä½�åœ°å�€
        info22: "", //ä»»è�Œæ—¶é—´
        info23: "", //ä»»è�Œå²—ä½�
        info24: "", //å�•ä½�ç”µè¯�
        info25: "", //å�•ä½�æ€§è´¨
        info26: "", //äººäº‹éƒ¨è�”ç³»äºº
        info27: "", //äººäº‹éƒ¨è�”ç³»ç”µè¯�
        info28: "", //ä¸ªäººå¹´æ”¶å…¥
        info29: "", //ä¼�ä¸šæˆ�ç«‹å¹´é™�
        info30: "", //å·²ç¼´ç¤¾ä¿�å¹´é™�
        state: "",
        address2: "",
        revenue: "",
        yearsInBusiness: "",
        industry: "",
        structure: "",
        zip: "",
        businessStartDate: '',
        ownOrRentLocation: '',
        rentOrMortgageAmount: ''
      },
      rules: {
        info1: [assignValidator("è¯·è¾“å…¥æ•°å­—zzz", "blur")],
        info6: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("EIN can not be empty"));
              }else if (_.trim(value).length != 10 ) {
                callback(new Error("TIN must be 9 digital"));
              } 
              else {
                callback();
              }
            }
          }
        ],
        info11: [
          {
            //æ‰€å±žåŒºåŸŸ
            require: true,
            trigger: "change",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("æ‰€å±žåŒºåŸŸä¸�èƒ½ä¸ºç©º"));
              } else {
                callback();
              }
            }
          }
        ],
        info13: [
          {
            // æˆ·ç±�åœ°å�€
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Can not be empty."));
              } else {
                callback();
              }
            }
          }
        ],
        info18: [
          {
            // å±…ä½�åŸŽå¸‚
            require: false,
            trigger: "change",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Can not be empty."));
              } else {
                callback();
              }
            }
          }
        ],
        info19: [
          {
            // å±…ä½�ä½�å�€
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Can not be empty."));
              } else {
                callback();
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    })
  },
  methods: {
    ...mapActions({
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      savePersonalInfoall: types.SAVE_PERSONAL_INFO_All,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),

    handleTinInput(value) {
      var newValue = value.replaceAll("-", "");
      if (newValue.length > 2) {
        this.myInfoFormModel.info6 = newValue.substr(0, 2) + "-" + newValue.substr(2);
      }
    },

    saveInfo() {
      this.$refs.myInfoForm.validate(valid => {
        if (valid) {
          this.isLoading = true;
          this.savePersonInfo();
        }
      });
    },

    submitForm() {
      var _this = this;
      this.$refs.myInfoFormModel.validate(valid => {
        if (valid) {
          this.isLoading = true;
          api
            .postForm("/mobile/item/loanItemFrontApply/updateSBL.ht", {
              tokenId: _this.userInfo.token,
              customerId: _this.userInfo.crmCustomerId,
              // frontApplyId: _this.userInfo.crmCustomerId,
              name: _this.myInfoFormModel.businessName,
              tradeName: _this.myInfoFormModel.tradeName || '',
              companyEmail: _this.myInfoFormModel.companyEmail || '',
              stateOfIncorporation: _this.myInfoFormModel.stateOfIncorporation || '',
              website: _this.myInfoFormModel.website || '',
              businessDesc: _this.myInfoFormModel.businessDesc || '',
              street: _this.myInfoFormModel.info21,
              street2: _this.myInfoFormModel.address2,
              city: _this.myInfoFormModel.info18,
              state: _this.myInfoFormModel.state,
              zipCode: _this.myInfoFormModel.zip,
              phone: _this.myInfoFormModel.info24,
              tin: _this.myInfoFormModel.info6              
            })
            .then(res => {
              var _data = res.data;
              if (_data.code == 0) {
                console.log(res);
                this.updateSBL01();
              } else {
                this.isLoading = false;
                this.setAlertMessage({
                  show: true,
                  content: _data.msg
                });

                _this.$router.push({
                  path: `/applyLoan/${this.$route.params.id}/sbl`,
                  query: {
                    applyLoanId: this.$route.query.applyLoanId,
                    isEdit: this.$route.query.isEdit
                  }
                });
              }
            });
        } else {
          return false;
        }
      });
    },

    updateSBL01() {
      var _this = this;
      this.$refs.myInfoFormModel.validate(valid => {
        if (valid) {
          api
            .postForm("/mobile/item/loanItemFrontApply/updateSBL01.ht", {
              tokenId: _this.userInfo.token,
              customerId: _this.userInfo.crmCustomerId,
              // frontApplyId: _this.userInfo.crmCustomerId,
              industry: _this.myInfoFormModel.industry,
              structure: _this.myInfoFormModel.structure,
              yearsInBusiness: _this.myInfoFormModel.yearsInBusiness,
              revenue: _this.myInfoFormModel.revenue
            })
            .then(res => {
              //             alert(res.date.code);
              //             alert(res.date.msg);
              var _data = res.data;
              if (_data.code == 0) {
                console.log(res);
                this.updateUpload();
              } else {
                this.isLoading = false;
                this.setAlertMessage({
                  show: true,
                  content: _data.msg
                });
              }
            });
        } else {
          return false;
        }
      });
    },

    updateUpload() {
      var updateData = {
        tokenId: this.userInfo.token,
        customerId: this.userInfo.crmCustomerId,

        businessStartDate: this.myInfoFormModel.businessStartDate,
        ownOrRentLocation: this.myInfoFormModel.ownOrRentLocation,
        rentOrMortgageAmount: this.myInfoFormModel.rentOrMortgageAmount
      }

      api.postForm("/mobile/item/loanItemFrontApply/updateUpload.ht", updateData)
        .then(res => {
          this.isLoading = false;
          var _data = res.data;
          if (_data.code == 0) {
            console.log(res);
            this.$router.push({
              path: `/personalCenter/myLoan/loanLists`,
              query: {
                frontApplyState: 0,
                pageCount: 1
              }
            });
          } else {
            this.setAlertMessage({
              show: true,
              content: _data.msg
            });
          }
        });
    },

    savePersonInfo() {
      //ä¿�å­˜æ•°æ�®
      this.savePersonalInfoall({
        token: this.userInfo.token,
        personSex: this.myInfoFormModel.info7,
        personBirthDate: this.myInfoFormModel.info8,
        personEducation: this.myInfoFormModel.info9,
        personCollege: this.myInfoFormModel.info10,
        a: this.myInfoFormModel.info11,
        personCategory: this.myInfoFormModel.info12,
        personCensusAddr: this.myInfoFormModel.info13,
        personMarital: this.myInfoFormModel.info14,
        personFamily: this.myInfoFormModel.info15,
        personExistChild: this.myInfoFormModel.info16,
        personHouse: this.myInfoFormModel.info17,
        b: this.myInfoFormModel.info18,
        personDwellAddr: this.myInfoFormModel.info19,
        personCompanyName: this.myInfoFormModel.info20, //å·¥ä½œå�•ä½�å…¨ç§°
        personCompanyAddr: this.myInfoFormModel.info21,
        personCompanyTime: this.myInfoFormModel.info22,
        personCompanyPost: this.myInfoFormModel.info23,
        personCompanyPhone: this.myInfoFormModel.info24,
        personCompanyNature: this.myInfoFormModel.info25,
        personCompanyLinkman: this.myInfoFormModel.info26,
        personCompanyLinkmanPhone: this.myInfoFormModel.info27,
        personYearIncome: this.myInfoFormModel.info28,
        personCompanyAge: this.myInfoFormModel.info29,
        personSocialSecurityTime: this.myInfoFormModel.info30
      }).then(res => {
        this.isLoading = false;
        if (Number(res.data.code) === 0) {
          this.setSuccessMessage({
            show: true,
            content: "ä¸ªäººä¿¡æ�¯ä¿�å­˜æˆ�åŠŸ"
          });
        } else {
          this.loading = false;
        }
      });
    },

    getMgxyDictionary() {
      var _this = this;
      api.mgxyDictionary().then(res => {
        _this.stateS = _this.formatData(res.data.result[0]);
      });
    },

    formatData(data) {
      var arr = [];
      for (var key in data) {
        var obj = {};
        obj.value = data[key];
        obj.text = key;
        arr.push(obj);
      }
      return arr;
    }
  },

  mounted() {
    document.title = "Business Info - American Credit";
    // this.getMgxyDictionary();
    this.getPersonalInitData({
      token: this.userInfo.token,
      customerId: this.userInfo.crmCustomerId
    }).then(res => {
      console.log(res);
      if (Number(res.data.code) === 0) {
        const data = res.data.result;
        this.myInfoFormModel = {
          info1: data.customerCode, //å®¢æˆ·ç¼–ç �

          //info2: data.customerType, //å®¢æˆ·ç±»åž‹ 1ä¸ªäºº 2ä¼�ä¸š

          info3: data.customerName, //å®¢æˆ·å§“å��
          info4: data.customerLoginName, //REGISTRATIONæ‰‹æœºå�·
          //info5: data.personDocumentType, //è¯�ä»¶ç±»åž‹
          info6: data.employer.tin, //è¯�ä»¶å�·ç �

          info7: data.title, //æ€§åˆ«
          info8: data.dateOfBirthStr, //å‡ºç”Ÿæ—¥æœŸ

          info9: data.educationCodeStr, //å­¦åŽ†
          info10: data.schoolName, //æ¯•ä¸šé™¢æ ¡

          //info11: 'æš‚æ— ', //æ‰€å±žåŒºåŸŸ
          // info12: data.personCategory, //æˆ·åˆ«
          //info13: data.personCensusAddr, //æˆ·ç±�åœ°å�€

          info14: data.maritaStatusStr, //å©šå§»çŠ¶å†µ
          // info15: data.personFamily, //å®¶åº­æˆ�å‘˜
          // info16: data.personExistChild, //æ˜¯å�¦æœ‰å­�å¥³
          info17: data.homeOwnershipStr, //ä½�å®…çŠ¶å†µ'

          info18: data.employer.city,
          //info18: '0', //å±…ä½�åŸŽå¸‚
          info19: data.streetAddress2, //å±…ä½�åœ°å�€

          businessName: data.employer.name,
          tradeName: data.employer.tradeName,
          companyEmail: data.employer.companyEmail || '',
          stateOfIncorporation: data.employer.stateOfIncorporation,
          website: data.employer.website,
          businessDesc: data.employer.businessDesc,
          info21: data.employer.street, //å�•ä½�åœ°å�€
          //info22: data.crmCustomerPerson.personCompanyTime, //ä»»è�Œæ—¶é—´
          // info23: data.crmCustomerPerson.personCompanyPost, //ä»»è�Œå²—ä½�
          info24: data.employer.phone, //å�•ä½�ç”µè¯�
          // info25: data.crmCustomerPerson.personCompanyNature, //å�•ä½�æ€§è´¨

          // info26: data.crmCustomerPerson.personCompanyLinkman, //äººäº‹éƒ¨è�”ç³»äºº
          //info27: data.crmCustomerPerson.personCompanyLinkmanPhone, //äººäº‹éƒ¨è�”ç³»ç”µè¯�
          info28: data.employer.monthlyNetIncome, //ä¸ªäººæœˆæ”¶å…¥
          // info29: data.crmCustomerPerson.personCompanyAge, //ä¼�ä¸šæˆ�ç«‹å¹´é™�
          //info30: data.crmCustomerPerson.personSocialSecurityTime  //å·²ç¼´ç¤¾ä¿�å¹´é™�

          state: data.employer.state,
          zip: data.employer.zipCode,
          address2: data.employer.street2,
          revenue: data.employer.revenue || '',
          structure: data.employer.structure,
          industry: data.employer.industry,
          yearsInBusiness: data.employer.yearsInBusiness || '',
          businessStartDate: data.employer.businessStartDate || '',
          ownOrRentLocation: data.employer.ownOrRentLocation || '',
          rentOrMortgageAmount: data.employer.rentOrMortgageAmount || ''
        };

        // make sure all old tin formatted
        if (this.myInfoFormModel.info6.length == 9) {
          var oldTin = this.myInfoFormModel.info6;
          this.myInfoFormModel.info6 = oldTin.substr(0, 2) + "-" + oldTin.substr(2);
        }
      }
    });
  }
};
</script>
<style lang="scss">
.el-input.is-disabled .el-input__inner {
  background: #f7f7f7;
}

.step1-form .step-form__title {
  padding-bottom: 120px;
}

.business_main {
  margin-top: 10px;
}

.second_title {
  padding: 3px 0px 15px 0px;
  color: #747474;
}

.business_main .el-form-item__label {
  text-align: center;
}

.business_main input {
  margin-left: 0;
}

.business_main .label_text .el-form-item__label {
  width: 14% !important;
}

.business_main .label_text .el-form-item__content {
  margin-left: 15% !important;
}

.select_width .el-input__icon + .el-input__inner {
  padding-right: 95px;
}

.Infosave {
  margin: 15px 0px;
}
</style>



// WEBPACK FOOTER //
// BusinessInfo.vue?3f77a7f2